import React, { useEffect, useState } from "react";
import Loading from "../../helperComponents/Loading";
import PasswordVerification from "./PasswordVerification";
import ResetPassword from "./ResetPassword";
import EmailVerification from "./EmailVerification";
import { getParams } from "../../util/common";
import { UNKNOWN } from "../../util/constants";

const Verification = (props) => {
  const [params, setParams] = useState({ mode: "loading" });

  useEffect(() => {
    setParams(getParams(document.location.href));
  }, []);

  const layout = {
    loading: <Loading />,
    resetPassword: <ResetPassword code={params.oobCode} />,
    verifyEmail: (
      <EmailVerification
        user={props.user}
        history={props.history}
        authenticated={props.authenticated}
        continueUrl={params.continueUrl}
        oobCode={params.oobCode}
      />
    ),
  };
  if (props.authenticated === UNKNOWN) {
    return layout.loading;
  }
  return layout[params.mode] || layout.verifyEmail;
};

export default Verification;
